/**
 * External dependencies
 */
import React from 'react';
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const TagGroup = ({ children, compact, className }) => {
	const classes = classnames('tag-group', { 'is-compact': compact }, className);

	return (
		<div className={classes}>
			{children}
		</div>
	);
};


export default TagGroup;
